// extracted by mini-css-extract-plugin
export default {"container":"App_container__Rt8T2","buildVersion":"App_buildVersion__uRhUa"};